/* eslint-disable simple-import-sort/imports */
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const UserCommonDialog = ({ open, onClose, selectedChat }: any) => {
  const [tabIndex, setTabIndex] = useState(1);
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 2,
          }}
        >
          {selectedChat?.picture ? (
            <img
              src={selectedChat?.picture}
              alt="Profile"
              className="h-10 w-10 rounded-full"
              style={{ border: '1px solid #d9d7d7' }}
            />
          ) : (
            <div className="flex h-10 w-10 items-center justify-center rounded-full border bg-[#73B1E9]">
              <div className="text-[24px] font-medium text-white">
                {selectedChat?.name?.charAt(0)?.toUpperCase()}
              </div>
            </div>
          )}
          <Box sx={{ textAlign: 'center', flexGrow: 1 }}>
            <Typography variant="h6" fontWeight="bold">
              {selectedChat?.name}
            </Typography>
            <Typography variant="body2" color="gray">
              {selectedChat?.statusId
                ? selectedChat.statusId
                : selectedChat?.uuid?.slice(0, 8).toUpperCase()}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Tabs */}
        <DialogContent sx={{ p: 0 }}>
          <Tabs
            value={tabIndex}
            onChange={(e, newIndex) => setTabIndex(newIndex)}
            sx={{
              '& .MuiTabs-flexContainer': {
                justifyContent: 'space-around',
              },
            }}
          >
            <Tab label="Images" />
            <Tab label="Video" />
            <Tab label="Files" />
          </Tabs>

          {/* Content - No Data Found */}
          {tabIndex === 0 && (
            <Box
              sx={{
                textAlign: 'center',
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <InsertDriveFileIcon sx={{ fontSize: 60, color: 'red' }} />
              <Typography variant="body1" fontWeight="bold" color="gray">
                No image found!
              </Typography>
            </Box>
          )}
          {tabIndex === 1 && (
            <Box
              sx={{
                textAlign: 'center',
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <InsertDriveFileIcon sx={{ fontSize: 60, color: 'red' }} />
              <Typography variant="body1" fontWeight="bold" color="gray">
                No video found!
              </Typography>
            </Box>
          )}
          {tabIndex === 2 && (
            <Box
              sx={{
                textAlign: 'center',
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <InsertDriveFileIcon sx={{ fontSize: 60, color: 'red' }} />
              <Typography variant="body1" fontWeight="bold" color="gray">
                No file found!
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UserCommonDialog;
